/* Connect VO Product Options color controls to Prestige's existing gallery.
   Keep variant selection, prices and cart handling entirely with the app. */
(() => {
  const data = document.getElementById('rpl-color-gallery-data');
  if (!data || window.rplColorGalleryReady) return;
  window.rplColorGalleryReady = true;
  const product = JSON.parse(data.textContent);
  const colorIndex = product.options.findIndex(name => /colou?r/i.test(name));
  if (colorIndex < 0) return;
  const gallery = document.querySelector('product-gallery');
  if (!gallery) return;
  gallery.classList.add('rpl-independent-gallery');
  const style = document.createElement('style');
  style.textContent = `@media(min-width:1000px){
    .rpl-independent-gallery{position:sticky;top:calc(var(--sticky-area-height, 0px) + 20px);align-self:start;min-width:0}
    .rpl-independent-gallery .product-gallery__carousel{grid-template-columns:minmax(0,1fr);grid-auto-flow:row;max-height:calc(100dvh - var(--sticky-area-height, 0px) - 40px)!important;overflow-y:auto;overflow-x:hidden;overscroll-behavior-y:contain;scrollbar-width:thin;scroll-snap-type:y proximity}
    .rpl-independent-gallery .product-gallery__media{grid-column:1!important;scroll-snap-align:start}
    .rpl-independent-gallery .product-gallery__media img{max-height:calc(100dvh - var(--sticky-area-height, 0px) - 40px);object-fit:contain}
    .rpl-independent-gallery .product-gallery__thumbnail-scroller{max-height:calc(100dvh - var(--sticky-area-height, 0px) - 40px)}
  }`;
  document.head.append(style);
  function selectDesktop(media) {
    if (!matchMedia('(min-width:1000px)').matches) return false;
    const carousel = gallery.querySelector('.product-gallery__carousel');
    carousel.scrollTo({top:carousel.scrollTop + media.getBoundingClientRect().top - carousel.getBoundingClientRect().top,behavior:'instant'});
    gallery.querySelectorAll('.product-gallery__thumbnail').forEach(button => button.setAttribute('aria-current', String(button.dataset.mediaId === media.dataset.mediaId)));
    return true;
  }
  gallery.addEventListener('click', event => {
    const button = event.target.closest('.product-gallery__thumbnail');
    if (!button || !matchMedia('(min-width:1000px)').matches) return;
    const media = gallery.querySelector(`.product-gallery__carousel [data-media-id="${button.dataset.mediaId}"]`);
    if (!media) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    selectDesktop(media);
  }, true);
  // Visually verified existing photos for products without Shopify assignments.
  const photos = {
    'lux-zippered-portfolio': {Hickory:'IMG-9468'},
    'leather-journal-university-colors': {Maroon:'A83195E0', 'Burnt Orange':'58FDDB42', Red:'0C9EE4A6'},
    'cowboy-duffle-crazy-horse-premium-leather': {'Oil-Tanned Cognac':'large_cognac.png', 'Oil-Tanned Burgundy':'319616bd'},
    'republic-shark-belt': {Black:'IMG-3261', Brown:'IMG-3262'},
    'leather-coaster-with-bottle-opener-2-pack': {'Black (2 pack)':'IMG-0177', 'Tan (2 pack)':'IMG-0176', '1 Black + 1 Tan':'IMG-0180'},
    'moreletii-crocodile-lux-slim-money-clip-wallet': {Brown:'IMG-7207', Black:'IMG-7207'},
    'leather-garment-bag-1': {'Oil Tanned':'IMG-6598', Hickory:'IMG-6598', Nicotine:'IMG-6598', 'Cognac Croc (Embossed)':'IMG-6598', 'Black Croc (Embossed)':'IMG-6598'}
  };
  let syncingFromGallery = false;
  let galleryGesture = false;
  const carousel = gallery.querySelector('.product-gallery__carousel');
  let viewedMedia = null;
  // VO calls scrollTo directly after a variant change. Block that automatic
  // jump until the shopper next interacts with the gallery or option controls.
  const scrollPhoto = carousel?.scrollTo.bind(carousel);
  if (scrollPhoto) carousel.scrollTo = (...args) => {
    if (viewedMedia && matchMedia('(max-width:999px)').matches) return;
    return scrollPhoto(...args);
  };
  const colors = [...new Set(product.variants.map(variant => variant.options[colorIndex]))];
  const normalize = value => value.toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  function photoColor(cell) {
    if (!cell || cell.dataset.mediaType !== 'image') return null;
    const assigned = [...new Set(product.variants
      .filter(variant => String(variant.media) === cell.dataset.mediaId)
      .map(variant => variant.options[colorIndex]))];
    if (assigned.length === 1) return assigned[0];
    const alt = ` ${normalize(cell.querySelector('img')?.alt || '')} `;
    const matches = colors.filter(color => alt.includes(` ${normalize(color)} `));
    return matches.length === 1 ? matches[0] : null;
  }
  ['pointerdown', 'touchstart', 'wheel', 'keydown', 'click'].forEach(type => {
    gallery.addEventListener(type, () => {
      if (matchMedia('(max-width:999px)').matches && !syncingFromGallery) {
        galleryGesture = true;
        viewedMedia = null;
      }
    }, {passive:true});
  });
  carousel?.addEventListener('carousel:settle', event => {
    if (!galleryGesture || syncingFromGallery || !matchMedia('(max-width:999px)').matches) return;
    galleryGesture = false;
    const color = photoColor(event.detail.cell);
    const app = document.getElementById('bcpo');
    if (!color || !app) return;
    const group = app.querySelector(`[data-option="option${colorIndex + 1}"]`);
    if (!group) return;
    const input = [...group.querySelectorAll('input[type="radio"]')].find(input => input.value === color);
    if (!input || input.disabled || input.checked) return;
    // Preserve size and use the app's normal variant, price and availability handling.
    const selections = product.options.map((_, index) => {
      const option = app.querySelector(`[data-option="option${index + 1}"]`);
      return option?.querySelector('input:checked')?.value || (option?.matches('select') ? option.value : option?.querySelector('select')?.value);
    });
    selections[colorIndex] = color;
    if (!product.variants.some(variant => variant.options.every((value, index) => !selections[index] || value === selections[index]))) return;
    clearTimeout(timer);
    gallery.dataset.rplGalleryColor = color;
    viewedMedia = event.detail.cell;
    syncingFromGallery = true;
    try {
      input.click();
    } finally { syncingFromGallery = false; }
  });
  let timer;
  document.addEventListener('click', event => {
    if (!syncingFromGallery && event.target.closest('#bcpo')) {
      delete gallery.dataset.rplGalleryColor;
      viewedMedia = null;
    }
  }, true);
  document.addEventListener('change', event => {
    const app = event.target.closest('#bcpo');
    if (!app || syncingFromGallery) return;
    galleryGesture = false;
    const group = event.target.closest('[data-option]');
    if (!group || group.dataset.option !== `option${colorIndex + 1}`) return;
    clearTimeout(timer);
    timer = setTimeout(() => {
      const colorGroup = app.querySelector(`[data-option="option${colorIndex + 1}"]`);
      const color = colorGroup?.querySelector('input:checked')?.value || (colorGroup?.matches('select') ? colorGroup.value : colorGroup?.querySelector('select')?.value);
      if (!color) return;
      const gallery = document.querySelector('product-gallery');
      if (gallery?.dataset.rplGalleryColor === color) return;
      const carousel = gallery?.querySelector('.product-gallery__carousel');
      if (!carousel) return;
      const variant = product.variants.find(v => v.options[colorIndex] === color && v.media);
      let media = variant && gallery.querySelector(`[data-media-id="${variant.media}"]`);
      if (!media) {
        const filename = photos[product.handle]?.[color];
        if (filename) media = [...carousel.querySelectorAll('[data-media-id]')].find(el => el.querySelector('img')?.src.includes(filename));
      }
      if (!media || media.hidden) return;
      if (selectDesktop(media)) return;
      const cells = [...carousel.querySelectorAll('[data-media-id]')].filter(el => !el.hidden);
      if (carousel.isScrollable && typeof carousel.select === 'function') carousel.select(cells.indexOf(media), {instant:true});
      const target = carousel.isScrollable ? gallery : media;
      const rect = target.getBoundingClientRect();
      if (rect.top < 0 || rect.bottom > innerHeight) target.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    }, 120);
  });
})();
